import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.css'
})
export class CookieBannerComponent {
  showBanner = signal(false);

  ngOnInit() {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      this.showBanner.set(true);
    }
  }

  acceptCookies() {
    localStorage.setItem('cookieConsent', 'accepted');
    this.showBanner.set(false);
  }

  rejectCookies() {
    localStorage.setItem('cookieConsent', 'rejected');
    this.showBanner.set(false);
    // Note: If rejected, you might want to disable non-essential cookies
    // For now, this just hides the banner
  }
}
